/********************************************************************************************
 * Responsibility - Serves as the main layout for the account page where the component in the
 * left represents the navigation and the component in the right represents the view
 * component.
 * ***********
 *
 * @format
 */

import React from 'react';

// styles
import './account_main_layout.scss';

export const AccountMainLayout = props => {
    const {
        children: [left, right]
    } = props;
    return (
        <div className="account-main-layout-36fk d-flex align-items-start justify-content-start">
            <section className={'account-main-layout-36fk__left flex-shrink-0'}>{left}</section>
            <main className={'account-main-layout-36fk__right'}>{right}</main>
        </div>
    );
};
